export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/lifestyle.d994981.svg";